import { motion } from 'framer-motion';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import LoadingLogo from './LoadingLogo';
import Seo from './Seo';

const Services = ({ withSeo = true }) => {
  const [services, setServices] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => { fetchServices(); }, []);

  const fetchServices = async () => {
    setIsLoading(true);
    try {
      const token = localStorage.getItem('token');
      const headers = token ? { Authorization: `token ${token}` } : {};
      const response = await axios.get('https://apifusion.synergyindustri.com/api/service-getall/', { headers });
      setServices(response.data || []);
    } catch (err) {
      console.error('Error fetching services:', err);
      setServices([]);
    } finally {
      setIsLoading(false);
    }
  };
  const handleChangePicture = (postId) => {
    console.log(`Change picture clicked for service ${postId}`);
    const handleImageChange = (event) => {
      const imageFile = event.target.files[0];
      if (imageFile) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const base64Image = e.target.result;
  
          const title = prompt('Enter the new title:');
          const description = prompt('Enter the new description:');
  
          if (title && description) {
            const token = localStorage.getItem('token');
            const headers = {
              Authorization: `token ${token}`,
            };
  
            axios
              .put(`https://apifusion.synergyindustri.com/api/services/${postId}/`, { image: base64Image, title, description }, { headers })
              .then((response) => {
                console.log('Image changed successfully:', response.data);
                fetchServices(); // Refresh the blog post list
              })
              .catch((error) => {
                console.error('Error changing image:', error);
              });
          }
        };
        reader.readAsDataURL(imageFile);
      }
    };
  
    const inputElement = document.createElement('input');
    inputElement.type = 'file';
    inputElement.accept = 'image/*';
    inputElement.addEventListener('change', handleImageChange);
    inputElement.click();
  };






































  // const handleAddImage = async () => {
  //   const fileInput = document.createElement('input');
  //   fileInput.type = 'file';
  //   fileInput.accept = 'image/*';
  //   fileInput.click();

  //   fileInput.onchange = async (e) => {
  //     const file = e.target.files[0];
  //     if (file) {
  //       const formData = new FormData();
  //       formData.append('image', file);

  //       try {
  //         const response = await axios.post('https://apifusion.synergyindustri.com/api/services/create/', formData);

  //         if (response.status === 200) {
  //           const newPost = {
  //             id: response.data.id,
  //             image: response.data.image,
  //             title: '',
  //             description: '',
  //           };

  //           setBlogPosts([...blogPosts, newPost]);
  //         }
  //       } catch (error) {
  //         console.error('Error adding image:', error);
  //       }
  //     }
  //   };
  // };



  const handleAddImage = () => {
    const handleImageChange = (event) => {
      const imageFile = event.target.files[0];
      if (imageFile) {
        const title = prompt('Enter the title:');
        const description = prompt('Enter the description:');
      
        if (title && description) {
          const reader = new FileReader();
          reader.onload = (e) => {
            const base64Image = e.target.result;
  
            const formData = new FormData();
            formData.append('image', base64Image);
            formData.append('title', title);
            formData.append('description', description);
     
      
  
            const token = localStorage.getItem('token');
            const headers = {
              Authorization: `token ${token}`,
              'Content-Type': 'multipart/form-data',
            };
  
            axios
              .post('https://apifusion.synergyindustri.com/api/services/create/', formData, { headers })
              .then((response) => {
                console.log('Image added successfully:', response.data);
                fetchServices(); // Refresh the blog post list
              })
              .catch((error) => {
                console.error('Error adding image:', error);
              });
          };
          reader.readAsDataURL(imageFile);
        }
      }
    };
  
    const inputElement = document.createElement('input');
    inputElement.type = 'file';
    inputElement.accept = 'image/*';
    inputElement.addEventListener('change', handleImageChange);
    inputElement.click();
  };



  const handleDelete = (postId) => {
    console.log(`Delete button clicked for blog post ${postId}`);
    const token = localStorage.getItem('token');
    const headers = {
      Authorization: `token ${token}`,
    };

    axios
      .delete(`https://apifusion.synergyindustri.com/api/services/${postId}/delete/`, { headers })
      .then((response) => {
        console.log('Blog post deleted successfully:', response.data);
        fetchServices(); // Refresh the blog post list
      })
      .catch((error) => {
        console.error('Error deleting blog post:', error);
      });
  };















  // const handleDelete = async (postId) => {
  //   try {
  //     const response = await axios.delete(`https://apifusion.synergyindustri.com/api/delete-blog-post/${postId}`);

  //     if (response.status === 200) {
  //       const updatedPosts = blogPosts.filter((post) => post.id !== postId);
  //       setBlogPosts(updatedPosts);
  //     }
  //   } catch (error) {
  //     console.error('Error deleting post:', error);
  //   }
  // };


  const [showFullDescription, setShowFullDescription] = useState({});
  const toggleDescription = (postId) => {
    setShowFullDescription(prev => ({ ...prev, [postId]: !prev[postId] }));
  };

  const isLoggedIn = !!(localStorage.getItem('token') && localStorage.getItem('user'));

  return (
    <div className="container mx-auto px-6 py-12">
      {withSeo ? (
        <Seo
          title={`Our Services - Fusion Tech`}
          description={`SCADA Solutions in Dubai, UAE, telemetry solutions, industrial automation, electrical and automation spare parts, PLC/RTU/DCS, control panels and machine supply from Dubai.`}
          keywords={`SCADA Solutions in Dubai, UAE, Telemetry Solutions in Dubai UAE, Industrial Automation Dubai UAE, Electrical Spare Parts in Dubai UAE, Automation Spare Parts Dubai UAE, PLC, RTU, DCS from Dubai, Control Panels from Dubai, Machine Supply from Dubai, Electromechanical Systems Supply and Installation in Dubai`}
        />
      ) : null}

      <header className="text-center mb-10">
        <h1 className="text-4xl font-bold">Our Services — Industrial Automation & Electromechanical Systems in Dubai</h1>
        <p className="mt-3 text-gray-600 max-w-2xl mx-auto">We provide turnkey automation, instrumentation, SCADA and telemetry solutions, control panels, PLC/RTU/DCS systems, and electromechanical supply & installation across Dubai and the UAE. Whether you need electrical spare parts, machine supply or full system integration, Fusion Tech delivers reliable Industrial Automation Dubai UAE services.</p>
        <p className="mt-3 text-gray-600 max-w-2xl mx-auto">
          Dedicated pages:{' '}
          <a className="text-fusion-blue font-medium" href="/scada-solutions-dubai">SCADA Solutions in Dubai, UAE</a>
          {' '}and{' '}
          <a className="text-fusion-blue font-medium" href="/electromechanical-systems-dubai">Electromechanical Systems Supply and Installation in Dubai</a>.
        </p>
      </header>

      {isLoggedIn && (
        <div className="mb-6 text-right">
          <button onClick={handleAddImage} className="inline-block bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded">Add Service</button>
        </div>
      )}

      {/* Company Profile removed — content moved out of Services page per request */}

      {isLoading ? (
        <div className="flex items-center justify-center py-16"><LoadingLogo /></div>
      ) : (
        <div className="space-y-12">
          {services.map((s, idx) => (
            <motion.article
              key={s.id}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.05 * idx }}
              className="grid grid-cols-1 lg:grid-cols-3 gap-6 items-center bg-white rounded-lg shadow-md overflow-hidden"
            >
              <div className="lg:col-span-2 p-6">
                <h2 className="text-2xl font-semibold mb-2">{s.title}</h2>
                <p className="text-gray-700 mb-4">{s.description}</p>
                {/* <div className="flex gap-3">
                  <a href="/Aboutus" className="inline-block bg-fusion-blue text-white px-4 py-2 rounded">Read Details</a>
                </div> */}
                {isLoggedIn && (
                  <div className="mt-4 flex justify-end gap-2">
                    <button onClick={() => handleChangePicture(s.id)} className="bg-fusion-primary hover:bg-fusion-blue-dark text-white px-3 py-1 rounded">Edit</button>
                    <button onClick={() => handleDelete(s.id)} className="bg-red-600 hover:bg-red-700 text-white px-3 py-1 rounded">Delete</button>
                  </div>
                )}
              </div>
              <div className="lg:col-span-1 h-56">
                <img src={s.image} alt={s.title} className="w-full h-full object-cover" />
              </div>
            </motion.article>
          ))}

          {/* Featured products removed per request */}
        </div>
      )}
    </div>
  );
};

export default Services;








// import { motion } from 'framer-motion';
// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import LoadingLogo from './LoadingLogo';

// const Services = () => {
//   const [blogPosts, setBlogPosts] = useState([]);
//   const [isLoading, setIsLoading] = useState(true);

//   useEffect(() => {
//     setIsLoading(true); // Set loading state to true before making the API call

//     axios
//       .get('https://apifusion.synergyindustri.com/api/blog-posts-getall/')
//       .then((response) => {
//         setBlogPosts(response.data);
//         setIsLoading(false); // Set loading state to false after receiving the response
//       })
//       .catch((error) => {
//         console.error('Error fetching blog posts:', error);
//         setIsLoading(false); // Set loading state to false in case of an error
//       });
//   }, []);

//   const handleChangePicture = async (postId) => {
//     // Rest of the code...
//   };

//   const handleAddImage = async () => {
//     // Rest of the code...
//   };

//   const handleDelete = async (postId) => {
//     // Rest of the code...
//   };

//   const isLoggedIn = !!(localStorage.getItem('token') && localStorage.getItem('user'));

//   return (
//     <div className="container mx-auto">
//       <h1 className="text-4xl font-bold my-8">Services</h1>
      
//       {isLoading ? ( // Check if loading state is true
//         <div className="flex items-center justify-center">
//           <LoadingLogo /> {/* Replace this with your loading spinner component */}
//         </div>
//       ) : (
//         <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
//           {blogPosts.map((blogPost) => (
//             <motion.div
//               key={blogPost.id}
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ delay: 0.2 }}
//               className="bg-gray-50 shadow-lg rounded-lg overflow-hidden hover:shadow-2xl hover:bg-gray-200 hover:cursor-pointer"
//             >
//               <img className="w-full h-48 object-cover" src={blogPost.image} alt={blogPost.title} />
//               <div className="p-4">
//                 <h3 className="text-xl font-medium mb-2">{blogPost.title}</h3>
//                 <p className="text-gray-600">{blogPost.description}</p>
//               </div>
//               {isLoggedIn && (
//                 <div className="p-2 flex flex-row justify-end gap-2">
//                   <button
//                     className="text-white hover:bg-blue-800 mr-2 bg-blue-600 rounded-lg px-4 py-1"
//                     onClick={() => handleChangePicture(blogPost.id)}
//                   >
//                     Edit
//                   </button>
//                   <button
//                     className="text-white hover:bg-red-800 mr-2 bg-red-600 rounded-lg px-4 py-1"
//                     onClick={() => handleDelete(blogPost.id)}
//                   >
//                     Delete
//                   </button>
//                 </div>
//               )}
//             </motion.div>
//           ))}
//           {isLoggedIn && (
//             <div className="w-full sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/4 p-4">
//               <div className="">
//                 <div className="h-48 flex items-center justify-center">
//                   <button onClick={handleAddImage} className="bg-green-500 text-white px-4 py-2 rounded-lg">
//                     Add Image
//                   </button>
//                 </div>
//               </div>
//             </div>
//           )}
//         </div>
//       )}
//     </div>
//   );
// };

// export default Services;